import React from "react";
import PropTypes from "prop-types";
import {
  InputTypeDropdown,
  InputTypeText,
  FieldSet,
  InputCardNumber,
  InputCardCvv,
  InputCardDate,
} from "../elements";
import { Form } from "informed";
import "react-credit-cards/es/styles-compiled.css";
import Cards from "react-credit-cards";
import { ButtonStyle } from "../../assets/css/components/ButtonStyle";
import ConfirmationModal from "../components/ConfirmationModal";

class CreditCardPaymentForm extends React.Component {
  state = {
    cvc: "",
    expiry: "",
    focus: "",
    name: "",
    number: "",
    showConfirmationModal: false,
    installments: 1,
  };

  handleInputFocus = (e) => {
    this.setState({ focus: e.target.name });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState({ [name]: value });
  };

  serializePaymentInfo = (paymentInfo) => {
    return {
      capture: this.props.capture,
      card_number: paymentInfo.number.replace(/ /g, ""),
      card_cvv: paymentInfo.cvc,
      card_expiration_date: paymentInfo.expiry,
      card_holder_name: paymentInfo.name,
      installments: paymentInfo.installments,
    };
  };

  onPay = () => {
    this.props.onPay(this.serializePaymentInfo(this.state));
    this.setState({ showConfirmationModal: false });
  };

  buildInstallmentForSelect = (i) => {
    return { label: i + "x Parcelas", value: i };
  };

  installmentOptions = () => {
    const { installments } = this.props;
    let rangeArray = [...Array(installments + 1).keys()];
    rangeArray.shift();
    return rangeArray.map(this.buildInstallmentForSelect);
  };

  render() {
    return (
      <div id="CreditCardPaymentForm">
        <Form>
          <FieldSet title="Informações do Cartão">
            <InputCardNumber
              field="creditCardNumber"
              label="Número do Cartão de Crédito"
              col="4"
              helper="Ex: 1234 4567 8910 1112"
              required
              name="number"
              onChange={this.handleInputChange}
              onFocus={this.handleInputFocus}
            />
            <InputCardCvv
              field="cardCvv"
              label="Código de Verificação (CVV)"
              col="4"
              helper="Ex: 123"
              required
              name="cvc"
              onChange={this.handleInputChange}
              onFocus={this.handleInputFocus}
            />
            <InputCardDate
              field="expirationDate"
              label="Data de expiração do Cartão"
              col="4"
              helper="Ex: 12/20"
              required
              name="expiry"
              onChange={this.handleInputChange}
              onFocus={this.handleInputFocus}
            />
            <InputTypeText
              field="cardHolderName"
              label="Nome do Titular do Cartão"
              col="5"
              helper=""
              required
              name="name"
              onChange={this.handleInputChange}
              onFocus={this.handleInputFocus}
            />
            <InputTypeDropdown
              field="installments"
              label="Parcelas"
              col="2"
              required
              options={this.installmentOptions()}
              onChange={this.handleInputChange}
            />
          </FieldSet>
          <Cards
            cvc={this.state.cvc}
            expiry={this.state.expiry}
            focused={this.state.focus}
            name={this.state.name}
            number={this.state.number}
          />
          <ButtonStyle
            onClick={() => this.setState({ showConfirmationModal: true })}
            className="mt-2 mb-4"
            type="submit"
          >
            EFETUAR PAGAMENTO de <b>{this.props.amount}</b>
          </ButtonStyle>
          <ConfirmationModal
            title="Confirmação do Pagamento"
            visible={this.state.showConfirmationModal}
            onCancel={() => this.setState({ showConfirmationModal: false })}
            onConfirm={() => this.onPay()}
            cancelText="Cancelar"
            confirmText="Pagar"
          >
            <label>
              Você confirma o pagamento de <b>{this.props.amount}</b> ?
            </label>
          </ConfirmationModal>
        </Form>
      </div>
    );
  }
}

CreditCardPaymentForm.propTypes = {
  onPay: PropTypes.func,
  capture: PropTypes.bool,
  amount: PropTypes.number,
};

CreditCardPaymentForm.defaultProps = {
  onPay: () => {},
  capture: true,
  amount: "R$0,0",
  installments: 1,
};

export default CreditCardPaymentForm
